<template>
  <div class="card shadow-sm border-0" :class="{ 'h-100': fullHeight }">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center" :class="{ 'mb-3': !!title }">
        <h5 class="card-title mb-0 fs-4 fw-bold" data-test-id="base-info-card-title">
          {{ title }}
        </h5>
        <slot name="extra-header" />
      </div>
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  title: {
    type: String,
    default: undefined,
  },
  fullHeight: {
    type: Boolean,
    default: false,
  },
})
</script>
